var map = {
	"./en.webp": "9e98",
	"./fa.webp": "ad7e",
	"./gb.webp": "a647",
	"./hi.webp": "4130",
	"./ja.webp": "f489",
	"./ko.webp": "f731",
	"./ru.webp": "cf87",
	"./tr.webp": "3e8f",
	"./vi.webp": "1f74",
	"./zh.webp": "6186"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "490d";